import { Link } from "react-router-dom";
import CaretIcon from "../../../svg/CaretIcon";

const Pagination = ({ currentPage, totalCount, pageSize, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  //When there is no records
  const safeCurrentPage = totalPages > 0 ? currentPage : 0;
  const lastIndex =  totalCount > 0 ? Math.min(safeCurrentPage * pageSize, totalCount) : 0;
  const firstIndex = totalCount > 0 ? (safeCurrentPage - 1) * pageSize + 1 : 0;

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  const visiblePages = pageNumbers.slice(
    Math.max(currentPage - 2, 0),
    Math.min(currentPage + 1, totalPages)
  );

  const isPrevDisabled = totalPages === 0 || currentPage === 1;
  const isNextDisabled = totalPages === 0 || currentPage === totalPages;

  return (
    <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
        <div className="bg-white rounded shadow d-sm-flex text-center justify-content-between align-items-center mt-3">
            <div className="dataTables_info">
                Showing {firstIndex} to {lastIndex} of {totalCount} entries
            </div>
            <div className="dataTables_paginate paging_simple_numbers mb-0 me-2">
                <Link className={`paginate_button previous ${isPrevDisabled ? 'disabled' : ''}`}
                    onClick={() => !isPrevDisabled && onPageChange((prev) => Math.max(prev - 1, 1))} >
                        <CaretIcon direction="right" width="25" height="25" />
                </Link>
                <span>
                    {visiblePages.map((page) => (
                        <Link key={page} className={`paginate_button ${currentPage === page ? 'current' : ''}`}
                            onClick={() => onPageChange(page)} >{page}</Link>
                    ))}
                </span>
                <Link className={`paginate_button next ${isNextDisabled ? 'disabled' : ''}`}
                    onClick={() => !isNextDisabled && onPageChange((prev) => Math.min(prev + 1, totalPages))} >
                        <CaretIcon direction="left" width="25" height="25" />
                </Link>
            </div>
        </div>
    </div>
  );
};

export default Pagination;


